module.exports = __webpack_public_path__ + "static/media/gas-pump-slash.ac6fad68.svg";